import React from 'react';
import PropTypes from 'prop-types';
import Link from 'next/link';

import { withTranslation } from 'language/i18n';

const ProfileSteps = ({ t, currentStep }) => {
  const classNameByStep = (step) => {
    if (currentStep === step) {
      return 'im-step-bar2__item im-step-bar2__item--inprogress';
    }

    return 'im-step-bar2__item';
  };

  return (
    <div className="col-md-5 col-lg-3">
      <aside className="im-left-menu">
        <nav className="im-step-bar2">
          <Link href="/profile/summary">
            <a className={classNameByStep('summary')}>
              <span className="im-step-bar2__item__text">{t('summary')}</span>
            </a>
          </Link>
          <Link href="/profile">
            <a className={classNameByStep('profile')}>
              <span className="im-step-bar2__item__text">{t('profile')}</span>
            </a>
          </Link>
          <Link href="/profile/password">
            <a className={classNameByStep('passwordProcess')}>
              <span className="im-step-bar2__item__text">{t('passwordProcess')}</span>
            </a>
          </Link>
          <Link href="/profile/payments">
            <a className={classNameByStep('myPayments')}>
              <span className="im-step-bar2__item__text">{t('myPayments')}</span>
            </a>
          </Link>
          <Link href="/profile/watchlist">
            <a className={classNameByStep('myWatchlist')}>
              <span className="im-step-bar2__item__text">{t('myWatchlist')}</span>
            </a>
          </Link>
          <Link href="/profile/offers">
            <a className={classNameByStep('myOffers')}>
              <span className="im-step-bar2__item__text">{t('myOffers')}</span>
            </a>
          </Link>
          <Link href="/profile/purchases">
            <a className={classNameByStep('myPurchases')}>
              <span className="im-step-bar2__item__text">{t('myPurchases')}</span>
            </a>
          </Link>
          <Link href="/profile/sales">
            <a className={classNameByStep('mySales')}>
              <span className="im-step-bar2__item__text">{t('mySales')}</span>
            </a>
          </Link>
        </nav>
      </aside>
    </div>
  );
};

ProfileSteps.propTypes = {
  currentStep: PropTypes.string,
  t: PropTypes.func,
};

export default withTranslation('common')(ProfileSteps);
